var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mdi:email"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.8,9.1 L11.0,12.1 L6.2,9.1 V7.9 L11.0,10.9 L15.8,7.9 M15.8,6.7 H6.2 C5.534,6.7 5.0,7.234 5.0,7.9 V15.1 A1.2,1.2 0 0,0 6.2,16.3 H15.8 A1.2,1.2 0 0,0 17.0,15.1 V7.9 C17.0,7.234 16.46,6.7 15.8,6.7 Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.511f92384e212c7f8cb4f8e3d3cf8769.svg";
export { ForwardRef as ReactComponent };